import gql from 'graphql-tag';

export const _PAYMENT_DOCUMENT = gql`
query getPaymentDocument(
	$participant: uuid!
	$recipient: uuid!
	$offset: Int
	$limit: Int
  ) {
	total: risolto_payment_document_aggregate(
	  where: {
		participant: { _eq: $participant }
		recipient: { _eq: $recipient }
	  }
	) {
	  aggregate {
		count
	  }
	}
	payment_documents: risolto_payment_document(
	  where: {
		participant: { _eq: $participant }
		recipient: { _eq: $recipient }
	  }
	  limit: $limit
	  offset: $offset
	  order_by: { is_open: desc, issue_date: desc_nulls_last }
	) {
	  reference
	  created_at
	  payment_number
	  participant
	  amount_currency
	  processing_status
	  custom_fields
	  origin
	  total_amount
	  open_amount
	  issue_date
	}
  }  
`;
